import { render, staticRenderFns } from "./Box13.vue?vue&type=template&id=c4dc206a&scoped=true&"
import script from "./Box13.vue?vue&type=script&lang=js&"
export * from "./Box13.vue?vue&type=script&lang=js&"
import style0 from "./Box13.vue?vue&type=style&index=0&id=c4dc206a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../src/h5-coursePage/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4dc206a",
  null
  
)

export default component.exports